import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-about',
  imports: [],
  templateUrl: './about.html',
  styleUrl: './about.css',
})
export class About {
  protected readonly customerUrl = environment.customerUrl;
  protected readonly partnerUrl = environment.partnerUrl;
  protected readonly riderUrl = environment.riderUrl;
  protected readonly erpAppUrl = environment.erpAppUrl;
}
